<template>
  <div class="row">
    <div class="col-sm-12"><br>
      <div
        class="container-fluid col-md-12"
        style="
          background: rgb(248, 249, 250);
          border-radius: 10px;
          box-shadow: 5px 5px 5px 5px #999999;
        "
        id="contenedor"
      >
       <u @click="irMenu()">
				<br><h6>Volver</h6>
            </u>
     <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<br>
								<img src="https://seguimiento.cmimbral.cl/assets/logo_tienda.png"  width="200" class="img-fluid" alt="Responsive image"><br>
								</div>
							</div>
							
    </div><br>

    <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<h3 class="text-center"><b>Personal Mimbral</b></h3><br>
                </div>
							</div>
							
    </div>
    
    <div id="bDocumento">
        
          <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-5">
              <input type="text" class="form-control "  id="persona" placeholder="Ingrese RUT o nombre" required="true"  style="border-color:rgb(237,126,37)">
            </div>
            <div class="col-sm">
              <button type="submit"  id="btnBuscar" class="btn btn-primary " @click="buscarSolicitudes1()"  style="background-color:rgb(0,56,143); border-color:rgb(237,126,37)"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </div><br><br>
     <div class="d-flex justify-content-center">
        
							<div class="row">
								<div class="col">
								<div>
        <table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
                
              <th>RUT</th>
              <th>NOMBRE</th>
              <th>SUCURSAL</th>
              <th>AREA</th>
              <th>FECHA</th>
              <th>DESCRIPCIÓN</th>
              <th>CANTIDAD</th>
              <th>APROX</th>
              <th>METODO PAGO</th>
              <th>GESTIONAR</th>
              <th>RECHAZAR</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in solicitudes" :key="x.key">
                
              <td>{{ x.rut }}</td>
              <td>{{ x.nombre }}</td>
              <td>{{ x.sucursal }}</td>
              <td>{{ x.area }}</td>
              <td>{{ x.fecha }}</td>
              <td>{{ x.descripcion }}</td>
              <td>{{ x.cantidad }}</td>
              <td>${{ x.precio }}</td>
              <td>{{ x.metodoPago }}</td>
              <td v-if="x.estado=='Pendiente'">
                
                <!--<button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="pasarVale(x.key,x.rut,x.nombre,x.area,x.sucursal,x.razon,x.rutrazon,x.descripcion,x.cantidad,x.metodoPago)"
                >
                 <i class="fas fa-file fa-2x"></i>
                </button>-->
                <router-link :to="{name: 'valessolicitados', params: { id: x.key,rut:x.rut,nombre:x.nombre,area:x.area,sucursal:x.sucursal,razon:x.razon,rutrazon:x.rutrazon,descripcion:x.descripcion,cantidad:x.cantidad,metodopago:x.metodoPago,convenio:x.convenio}}" >Gestionar</router-link>
              </td>
              <td v-else>
                
                <!--<button 
                
                  type="button"
                  
                  class="btn btn-success btn-sm"
                  style="
                    background-color: rgb(0, 56, 143);
                    color: white;
                    border-color: rgb(237, 126, 37);
                  "
                  @click="pasarVale(x.key,x.rut,x.nombre,x.area,x.sucursal,x.razon,x.rutrazon,x.descripcion,x.cantidad,x.metodoPago)"
                >
                 <i class="fas fa-file fa-2x"></i>
                </button>-->
                {{x.estado}}
              </td>
              <td>
                <button 
                
                  type="button"
                  
                  class="btn btn-danger btn-sm"
                  
                  @click="rechazar(x.key)"
                >
                 <i class="fas fa-ban"></i>
                </button>
              </td>
              
              
            </tr>
          </tbody>
        </table></div>
        <div id="btnExcel1" >
 <div class="d-flex justify-content-center">
        <div class="row">
          <div class="col">
  <export-excel
    class   = "btn btn-default"
    :data   = "solicitudes"
    :fields = "json_fields"
    worksheet = "Resumen"
    name    = "Resumen Solicitudes">
 
    <button class="btn btn-success btn-block"  >Generar Excel</button><br><br>
 
</export-excel>
          </div>
        </div>
        
      </div>
    </div>        
        <br><br>
        <div class="row">
          <div class="col-sm-6">
<h4>Resumen total por tipo convenio 1</h4>
<table class="table table-striped table-responsive" style="display:block">
      <thead style="background-color:rgb(0,58,140);color:white">
        <tr>
          <th>TIPO</th>
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in sortedTotales" :key="index">
          <td>{{ item.descripcion }}</td>
          <td>{{ item.total }}</td>
        </tr>
      </tbody>
    </table>
        <!--<table class="table table-striped table-responsive" style="display:block">
           <thead style="background-color:rgb(0,58,140);color:white">
            <tr>
                
              <th>TIPO</th>
              <th>TOTAL</th>
              
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Gas 5KG</td>
              <td>{{totalGas5}}</td>
            </tr>
            <tr>
              <td>Gas 11KG</td>
              <td>{{totalGas11}}</td>
            </tr>
            <tr>
              <td>Gas 15KG</td>
              <td>{{totalGas15}}</td>
            </tr>
            <tr>
              <td>Abastible 5KG</td>
              <td>{{totalAbastible5}}</td>
            </tr>
            <tr>
              <td>Abastible 11KG</td>
              <td>{{totalAbastible11}}</td>
            </tr>
            <tr>
              <td>Abastible 15KG</td>
              <td>{{totalAbastible15}}</td>
            </tr>
            <tr>
              <td>Abastible 45KG</td>
              <td>{{totalAbastible45}}</td>
            </tr>
           
          </tbody>
        </table>-->

          </div>

        <div class="col-sm">
<h4>Resumen total por tipo convenio 2</h4>
  <table class="table table-striped table-responsive" style="display:block">
      <thead style="background-color:rgb(0,58,140);color:white">
        <tr>
          <th>TIPO</th>
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in sortedTotales2" :key="index">
          <td>{{ item.descripcion }}</td>
          <td>{{ item.total }}</td>
        </tr>
      </tbody>
    </table>

          </div>


        </div>

                </div>
							</div>
							
    </div><br>
							

        <br>
         
       
       <!-- <iframe id="pdf" width="100%" height="800px"></iframe>-->
      </div>
    </div>
    <div>

   <b-modal id="modal-1" hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Agregar Producto</b></h3><br>
           
                <div class="row">
                    <div class="col-sm-6">
                         <div class="form-group">
                        <label>DESCRIPCIÓN</label>
                        <input type="text" id="descripcion"  class="form-control" placeholder="Ingrese descripción" style="border-color:rgb(237,126,37)"  required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="form-group">
                        <label>PRECIO</label>
                        <input type="text" id="precio"  class="form-control" placeholder="Ingrese precio aprox." style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    
                    
                </div><br>
                
                
                
                <div class="row">
                    <div class="form-group">
                        <label for="observacion">Observacion</label>
                        <textarea class="form-control" id="observacion" rows="3"  style="border-color:rgb(237,126,37)"></textarea><br>
                    </div>
                </div>
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="agregarProducto2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Agregar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>   

  <b-modal id="modal-2"  hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Editar Cupo</b></h3><br>
      
                
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label>CUPO</label>
                        <input type="text" id="cupoEditar" v-model="cupoEditar" class="form-control" placeholder="Ingrese cupo máximo" style="border-color:rgb(237,126,37)" required>
                        </div>
                    </div>
                    <div class="col-sm-6">
                      <label>ESTADO</label>
                      <select class="form-select" aria-label="Default select example" id="estadoEditar" style="border-color: rgb(237, 126, 37);">
                      <option value="ACTIVO">ACTIVO</option>
                      <option value="INACTIVO">INACTIVO</option>
                      </select>
                    </div>
                   
                </div><br>
                
                
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="editarProducto2()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Editar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>

  <b-modal id="modal-rechazo"  hide-footer hide-header >
    
    <div class="d-block text-center">
      <h3><b>Rechazar solicitud</b></h3><br>
      
                <input type="text" class="form-control " v-model="keyRechazo"  required="true"  style="display:none">
                
               <input type="text" class="form-control " v-model="motivoRechazo" placeholder="Ingrese motivo del rechazo" required="true"  style="border-color:rgb(237,126,37)">
                
                
               <!-- <div class="row" >
                    <div class="col-sm-6">
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="image/*" >
                    </div>

                </div>--><br>

                
                <div class="d-flex justify-content-center">
                    <div class="form-group">
                        <button class="btn btn-primary btn-block" @click="rechazarSolicitud()" style="background-color: rgb(0, 56, 143); color: white; border-color: rgb(237, 126, 37);">Actualizar</button><br><br>
                    </div>
                </div>

    </div>

  </b-modal>
</div>
  </div>
  
</template>

<script>
import { db } from "../firebaseDb";
//import { storage } from "../firebaseDb";
import Swal from "sweetalert2";
import Vue from 'vue'
    import { BootstrapVue } from 'bootstrap-vue'
    import excel from 'vue-excel-export'
    Vue.use(BootstrapVue)
    Vue.use(excel)
//const ref = storage.ref();

export default {
  data() {
    return {


      solicitudes: [],
      vendedores:[],
      editado:[],
      chequeEditado:[],
      observacion:'',
      sku:'',
      descripcion:'',
      precio:'',
      stock:'',
      FoliosSap:[],
      FoliosAsignar:[],
      totalFoliosAsignar:0,
      resumenFoliosAsignar:'',
      montoTransferencia:0,
      diferenciaMontos:0,
      idDocumentoFb:'',
      foliosAntiguos:'',
      rutBuscarFolios:'',
      fecha2BF:'',
      fecha1BF:'',
      tipoMonto:'',
      skuEditar:'',
      descripcionEditar:'',
      cupoEditar:'',
      keyEditar:'',
      cupoActual:'',
      totalGas5:0,
      totalGas11:0,
      totalGas15:0,
      totalGas45:0,

      totalAbastible5:0,
      totalAbastible11:0,
      totalAbastible15:0,
      totalAbastible45:0,
      totalHarina:0,
      totalHuevos:0,
      totalMix:0,
      totales:{},
      totales2:{},
      keyRechazo:'',
      motivoRechazo:'',
      json_fields: {
            'RUT': 'rut',
            'NOMBRE': 'nombre',
            'PRODUCTO': 'descripcion',
            'CANTIDAD': 'cantidad',
            'PRECIO': 'precio',
            'METODO PAGO': 'metodoPago',
            'FECHA': 'fecha',
            'SUCURSAL':'sucursal',
            'RAZON':'razon',
            'CONVENIO':'convenio',
            'ESTADO':'estado',
        },
    };
  },
  created() {
   
            this.usuario=localStorage.nombreUsuario;
            //console.log(this.usuario)
            //this.cargarProductos();
            this.validarUsuario();  
            this.cargarSolicitudes()
  },
  computed: {
    sortedTotales() {
      return Object.entries(this.totales)
        .map(([descripcion, total]) => ({ descripcion, total }))
        .sort((a, b) => a.descripcion.localeCompare(b.descripcion));
    },
    sortedTotales2() {
      return Object.entries(this.totales2)
        .map(([descripcion, total]) => ({ descripcion, total }))
        .sort((a, b) => a.descripcion.localeCompare(b.descripcion));
    },
  },
  methods: {
    /*cargarSolicitudes(){
            db.collection('pedido').where("estado", "==", "Pendiente").orderBy("fr","desc").orderBy("hora","desc").onSnapshot((snapshotChange) => {
                      this.solicitudes = [];
                      this.totalGas5=0
                      this.totalGas11=0
                      this.totalGas15=0
                      this.totalGas45=0
                      this.totalAbastible5=0
                      this.totalAbastible11=0
                      this.totalAbastible15=0
                      this.totalAbastible45=0
                      this.totalHarina=0
                      this.totalHuevos=0
                      this.totalMix=0
                if(snapshotChange.empty){
                    console.log("nada")
                }else{
                   
                    snapshotChange.forEach((doc) => {
                      console.table(doc.data())
                        this.solicitudes.push({
                        key: doc.id,
                            
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          rutrazon: doc.data().rutrazon,
                          razon: doc.data().razon,
                          descripcion: doc.data().descripcion, 
                          metodoPago: doc.data().metodoPago, 
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          estado: doc.data().estado,
                          convenio: doc.data().convenio,
                          
                        })
                        if(doc.data().descripcion=="GAS 15KG"){
                          this.totalGas15=parseInt(this.totalGas15)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="GAS 5KG"){
                          this.totalGas5=parseInt(this.totalGas5)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="GAS 11KG"){
                          this.totalGas11=parseInt(this.totalGas11)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="GAS 45KG"){
                          this.totalGas45=parseInt(this.totalGas45)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="ABASTIBLE 15KG"){
                          this.totalAbastible15=parseInt(this.totalAbastible15)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="ABASTIBLE 5KG"){
                          this.totalAbastible5=parseInt(this.totalAbastible5)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="ABASTIBLE 11KG"){
                          this.totalAbastible11=parseInt(this.totalAbastible11)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="ABASTIBLE 45KG"){
                          this.totalAbastible45=parseInt(this.totalAbastible45)+parseInt(doc.data().cantidad);
                        }else if(doc.data().descripcion=="HARINA 25KG"){
                          this.totalHarina=parseInt(this.totalHarina)+parseInt(doc.data().cantidad);
                        }
                        else if(doc.data().descripcion=="BANDEJA DE HUEVOS "){
                          this.totalHuevos=parseInt(this.totalHuevos)+parseInt(doc.data().cantidad);
                        }
                        else if(doc.data().descripcion=="MIX PARRILLERO"){
                          this.totalMix=parseInt(this.totalMix)+parseInt(doc.data().cantidad);
                        }

                });
              }
          })
    },*/
    cargarSolicitudes() {
    db.collection('pedido').where("estado", "==", "Pendiente").orderBy("fr", "desc").orderBy("hora", "desc").onSnapshot((snapshotChange) => {
        this.solicitudes = [];
        this.totales = {};
        this.totales2 = {};
        if (snapshotChange.empty) {
            console.log("nada");
        } else {
            snapshotChange.forEach((doc) => {
                console.table(doc.data());
                this.solicitudes.push({
                    key: doc.id,
                    rut: doc.data().rut,
                    nombre: doc.data().nombre,
                    area: doc.data().area,
                    sucursal: doc.data().sucursal, 
                    rutrazon: doc.data().rutrazon,
                    razon: doc.data().razon,
                    descripcion: doc.data().descripcion, 
                    metodoPago: doc.data().metodoPago, 
                    cantidad: doc.data().cantidad,
                    precio: doc.data().precio,
                    fecha: doc.data().fecha + " " + doc.data().hora,
                    estado: doc.data().estado,
                    convenio: doc.data().convenio
                });

                if(doc.data().convenio=='1'){
                  const descripcion = doc.data().descripcion;
                  if (!Object.prototype.hasOwnProperty.call(this.totales, descripcion)) {
                      this.totales[descripcion] = 0;
                  }
                  this.totales[descripcion] += parseInt(doc.data().cantidad);
                }
                else if(doc.data().convenio=='2'){
                  const descripcion2= doc.data().descripcion;
                  if (!Object.prototype.hasOwnProperty.call(this.totales2, descripcion2)) {
                      this.totales2[descripcion2] = 0;
                  }
                  this.totales2[descripcion2] += parseInt(doc.data().cantidad);
                }
                
            });
        }
    });
},

    pasarVale(key,rut,nombre,area,sucursal,razon,rutrazon,descripcion,cantidad,metodoPago){
        console.log(key,rut,nombre,area,sucursal,razon,rutrazon,descripcion,cantidad,metodoPago)
        
    },

    buscarSolicitudes1(){
      var dato=document.getElementById("persona").value.toUpperCase();
            db.collection('pedido').where("estado", "==", "Pendiente").where("rut", "==", dato).orderBy("fr","desc").onSnapshot((snapshotChange) => {
                this.solicitudes = [];
                if(snapshotChange.empty){
                    this.buscarSolicitudes2()
                }else{
                    snapshotChange.forEach((doc) => {
                        this.solicitudes.push({
                        key: doc.id,
                            
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          rutrazon: doc.data().rutrazon,
                          razon: doc.data().razon,
                          descripcion: doc.data().descripcion, 
                          metodoPago: doc.data().metodoPago, 
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          estado: doc.data().estado,
                          convenio: doc.data().convenio,
                        })
                });
                }
          })
    },

    buscarSolicitudes2(){
      var dato=document.getElementById("persona").value.toUpperCase();
            db.collection('pedido').orderBy('nombre').startAt(dato).endAt(dato+'\uf8ff').onSnapshot((snapshotChange) => {
                this.solicitudes = [];
                if(snapshotChange.empty){
                    Swal.fire({
                      title: "Error",
                      text: "No se encontraron datos, debe para entregar un producto debe hacerlo de forma manual",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                        this.solicitudes.push({
                        key: doc.id,
                            
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          rutrazon: doc.data().rutrazon,
                          razon: doc.data().razon,
                          descripcion: doc.data().descripcion, 
                          metodoPago: doc.data().metodoPago, 
                          cantidad: doc.data().cantidad,
                          precio: doc.data().precio,
                          fecha: doc.data().fecha+" "+doc.data().hora,
                          estado: doc.data().estado,
                          convenio: doc.data().convenio,
                        })
                });
                }
          })
    },


    buscarPersona(){
        var rut=document.getElementById("persona").value.toUpperCase();
        db.collection('colaborador').where("rut", "==", rut).onSnapshot((snapshotChange) => {
                this.Personas = [];
                if(snapshotChange.empty){
                   this.buscarPersona2()
                }else{
                    snapshotChange.forEach((doc) => {
                      console.log(doc.data())
                          this.Personas.push({
                          key: doc.id,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          cupo: doc.data().cupo, 
                          cupodisponible: doc.data().cupodisponible, 
                      })
                   
                });
                }
          })
    },

    buscarPersona2(){
        var rut=document.getElementById("persona").value.toUpperCase();
        db.collection('colaborador').orderBy('nombre').startAt(rut).endAt(rut+'\uf8ff').onSnapshot((snapshotChange) => {
                this.Personas = [];
                if(snapshotChange.empty){
                   Swal.fire({
                      title: "Error",
                      text: "No se encontraron datos",
                      icon: "error",
                    });
                }else{
                    snapshotChange.forEach((doc) => {
                          this.Personas.push({
                          key: doc.id,
                          rut: doc.data().rut,
                          nombre: doc.data().nombre,
                          area: doc.data().area,
                          sucursal: doc.data().sucursal, 
                          cupo: doc.data().cupo, 
                          cupodisponible: doc.data().cupodisponible, 
                      })
                   
                });
              }
          })
    },

    editarCupo(key,nombre,cupoActual,cupodisponible){
      console.log(cupodisponible)
      //console.log(key,nombre)
       this.$bvModal.show("modal-2")
       this.keyEditar=key;
       this.cupoActual=cupoActual;
       this.cupoDisponible=cupodisponible
       //document.getElementById("keyEditar").value=key
       
    },

    editarProducto2(){
      var cupo=document.getElementById("cupoEditar").value;
      var estado=document.getElementById("estadoEditar").value;
      var cupoActual=this.cupoActual;
      var dif=parseInt(cupo)-parseInt(cupoActual)
      console.log(cupo,cupoActual,dif,this.cupoDisponible)
      var nuevoDisponible=parseInt(this.cupoDisponible)+parseInt(dif)
      console.log(nuevoDisponible)
      if(cupo!="" && estado!=""){
        db.collection('colaborador').doc(this.keyEditar)
                        .update({cupo:cupo,cupodisponible:nuevoDisponible}).then(() => {
                            Swal.fire({
                                title: "Listo",
                                text: "Cupo Actualizado",
                                icon: "success",
                            })
                            this.$bvModal.hide("modal-2")
                            document.getElementById("cupoEditar").value=""
                            document.getElementById("estadoEditar").value=""
                            //document.getElementById("keyEditar").value=""
                        }).catch((error) => {
                            console.log(error);
                        });
      }else{
          Swal.fire({
                        title: "Error",
                        text: "Debe completar los campos",
                        icon: "error",
                    })
      }
                        
    },
    

     validarUsuario(){
             //document.getElementById("monto").display = "none";   
            if(this.usuario==undefined || this.usuario=="X"){
                this.$router.push('/')
            }
        },

      irMenu(){
                if(localStorage.tipoUsuario=="1"){
                    this.$router.push('/menu')
                }else if(localStorage.tipoUsuario=="2" || localStorage.tipoUsuario=="3"){
                    this.$router.push('/menutransportes')
                }
            },
      leer(){
                var rut = document.getElementById("rut").value;
				var rutx=rut.replace("-","");
				var largo=rutx.length
				//console.log(largo,largo-1)
				var rut2=rutx.slice(0,largo-1)
				var rut3=rutx.slice(largo-1)
                //console.log(rut2+"-"+rut3)
				document.getElementById("rut").value=(rut2+"-"+rut3)
				
        },

    rechazar(key){
        this.keyRechazo=key
        this.$bvModal.show("modal-rechazo")
    },
    rechazarSolicitud(){
                        db.collection('pedido').doc(this.keyRechazo)
                        .update({estado: 'Rechazada por '+this.motivoRechazo}).then(() => {
                           this.$bvModal.hide("modal-rechazo")
                           Swal.fire({
                            title: "Listo",
                            text: "Solicitud Rechazada",
                            icon: "success",
                            
                          })
                        }).catch((error) => {
                            console.log(error);
                        });
    },
     
    
  },
};
</script>

<style>
.btn-primary {
  margin-right: 12px;
}
</style>